import { render, staticRenderFns } from "./StepNameEmail.vue?vue&type=template&id=4d08f556&scoped=true&"
import script from "./StepNameEmail.vue?vue&type=script&lang=js&"
export * from "./StepNameEmail.vue?vue&type=script&lang=js&"
import style0 from "./StepNameEmail.vue?vue&type=style&index=0&id=4d08f556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08f556",
  null
  
)

export default component.exports